export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const imgLogo = require('../assets/logo_img.png');
export const imgLogoText = require('../assets/logo_text.png');
export const imgLogoRound = require('../assets/logo.png');
export const clockImg = require('../assets/clock.png')
